module.exports = __webpack_public_path__ + "static/media/仓间调拨_07.fc0de375.jpg";